import PropTypes, { bool, elementType, string } from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { NamedRedirect } from '../components';
import { selectCurrentUser } from '../ducks/user.duck';
import { PROVIDER_USER_TYPE } from '../extensions/account-settings/config/users';

const ONBOARDING_PAGE = '/book/draft/00000000-0000-0000-0000-000000000000/new/details';
const ONBOARDING_PARAMS = { slug: 'draft', id: '00000000-0000-0000-0000-000000000000', type: 'new', tab: 'details' };
const DASHBOARD_PAGE = '/dashboard';

const WithAuthCheck = ({
  component: Component,
  auth = false,
  authPage = 'SignupPage',
  extraProps = {},
}) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const currentUser = useSelector(selectCurrentUser);
  const { pathname, search, hash } = useLocation();

  const currentUserLoaded = !!currentUser?.id;
  const isProvider = currentUser?.attributes.profile.publicData.userType === PROVIDER_USER_TYPE;
  const onboardingPosition = currentUser?.attributes.profile.publicData?.onboardingPosition;

  if (
    isAuthenticated &&
    currentUserLoaded &&
    isProvider &&
    onboardingPosition === 'welcome' &&
    pathname !== ONBOARDING_PAGE &&
    pathname !== DASHBOARD_PAGE
  ) {
    return <NamedRedirect name="EditListingPage" params={ONBOARDING_PARAMS} search="?first-time=true" />;
  }

  const canShow = auth ? isAuthenticated : true;
  return canShow ? (
    <Component {...extraProps} />
  ) : (
    <NamedRedirect
      name={authPage}
      state={{
        from: pathname + search + hash,
      }}
    />
  );
};

WithAuthCheck.propTypes = {
  component: elementType.isRequired,
  auth: bool,
  authPage: string,
  extraProps: PropTypes.object,
};

export default WithAuthCheck;
